/**
 * 紙・Webマニフェスト管理 運搬終了報告
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest/rest_manifests`

const rest_manifest_transport = {
  namespaced: true,
  actions: {
    /**
     * 紙・Web運搬報告の取得
     * @param commit
     * @param manifest_id
     * @param id
     * @return {Promise<unknown>}
     */
    show ({ commit }, { manifest_id, id }) {
      const api_path = `${API_PATH}/${manifest_id}/manifest_transports/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    /**
     * 紙・Web運搬報告の修正
     * @param commit
     * @param id
     * @param params
     * @return {Promise<unknown>}
     */
    update ({ commit }, { manifest_id, id, params }) {
      return new Promise( ( resolve ) => {
        const api_path = `${API_PATH}/${manifest_id}/manifest_transports/${id}`
        Vue.$http.put(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    /**
     * 紙・Web運搬報告の取消
     * @param commit
     * @param manifest_id
     * @param id
     * @return {Promise<unknown>}
     */
    destroy ({ commit }, { manifest_id, id }) {
      return new Promise( ( resolve ) => {
        const api_path = `${API_PATH}/${manifest_id}/manifest_transports/${id}`
        Vue.$http.delete(api_path).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '取消しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
}

export default rest_manifest_transport
